import { useMemo } from 'react';
import { usePurchasePlanningWeekParams } from '@/features/purchase-planning/hooks/use-purchase-planning-week-params';
import { GET_PURCHASE_PLANNING_KEY } from '@/keys';

export function usePurchasePlanningWeek() {
  const { weekParams } = usePurchasePlanningWeekParams();
  const queryKey = useMemo(
    () =>
      [...GET_PURCHASE_PLANNING_KEY, weekParams.year, weekParams.week] as const,
    [weekParams.year, weekParams.week],
  );

  return {
    queryKey,
    weekParams,
  };
}
